import React from "react";
import { SearchIcon } from "../../Icons";
import HorizontalScroll from "../common/HorizontalScroll";

export default function SearchResult() {
  return (
    <div className="pb-10 min-h-[300px]">
      <form action="" className="p-5 flex items-center gap-2.5 max-w-[305px]">
        <input
          type="text"
          className="rounded-[3px] border border-[#BABABA] bg-white py-[5px] px-2 text-[#242424] text-[12px] outline-none flex-1 w-full"
          value={431}
          required
        />
        <button className="w-[80px] bg-[#08F] flex items-center justify-center ps-4 py-0.5 rounded-[3px]">
          <SearchIcon color="#fff" />
        </button>
      </form>
      <div className="px-2.5">
        <HorizontalScroll
          className="w-full max-h-[250px]"
          overflow="overflow-auto"
        >
          <table className="flex-1 w-full text-[12px] text-[#242424] text-center border border-[#C9C9C9]/30 border-t-0 whitespace-nowrap relative">
            <thead className="sticky top-0 z-[2]">
              <tr className="font-normal divide-x divide-[#C9C9C9]/30 bg-[#DBDBDB]">
                <th className="py-1 px-2.5">ips</th>
                <th className="py-1 px-2.5">emrs</th>
                <th className="py-1 px-2.5">des</th>
                <th className="py-1 px-2.5">act_bs</th>
                <th className="py-1 px-2.5">act_bf</th>
                <th className="py-1 px-2.5">act_as</th>
              </tr>
            </thead>
            <tbody>
              {["", "", "", "", "", "", "", "", ""].map((_, idx) => (
                <tr
                  key={idx}
                  className="bg-[#F1F1F1] font-light border-t border-[#C9C9C9]/30 divide-x divide-[#C9C9C9]/30 hover:bg-[#EDF0FA] transition-all duration-200 ease-linear"
                >
                  <td className="py-1 px-2.5">50215478521</td>
                  <td className="py-1 px-2.5">52487fjdjhfjdhf 0100</td>
                  <td className="py-1 px-2.5">PLANT CONCAETE FACUTES</td>
                  <td className="py-1 px-2.5">2025-12-01</td>
                  <td className="py-1 px-2.5">2025-12-01</td>
                  <td className="py-1 px-2.5"></td>
                </tr>
              ))}
            </tbody>
          </table>
        </HorizontalScroll>
      </div>
    </div>
  );
}
